<template>
  <section class="page">
    <div id="page-main">
      <h2>Breweries to approve</h2>
      <table v-if="this.breweries.length>0">
        <thead>
          <tr>
            <th>Brewery Name</th>
            <th>Phone Number</th>
            <th>Address</th>
            <th>Hours</th>
            <th>Owner ID</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="brewery in breweries" v-bind:key="brewery.breweryId">
            <td>{{brewery.breweryName}}</td>
            <td>{{brewery.phoneNumber}}</td>
            <td>{{brewery.address}}</td>
            <td>{{brewery.hours}}</td>
            <td>{{brewery.owner}}</td>
            <td><button class="button" v-on:click="approveBrewery(brewery)">Approve</button></td>
            <td><button class="button" v-on:click="deleteBrewery(brewery.breweryId)">Delete</button></td>
          </tr>
        </tbody>
      </table>
      <p v-if="this.breweries.length===0">There are no breweries to approve.</p>
      <br />
      <get-users />
    </div>
  </section>
</template>

<script>
import GetUsers from './GetUsers.vue';
export default {
  name: "admin-table",
  components: {
    GetUsers
  },
  data() {
    return {
    };
  },
  methods: {
    approveBrewery(brewery) {
      this.$store.commit("APPROVE_BREWERY",brewery);
    },
    deleteBrewery(id) {
      this.$store.commit("DELETE_BREWERY",id);
    }
  },
  computed: {
    breweries () {
      return this.$store.getters.getUnapproved
    }
  }
};
</script>

<style>

</style>